import { Injectable, Injector } from '@angular/core';
import { BaseService } from 'src/app/common/base/base.service';
import { RoleScheduleTypeSubscription } from '../models/role-schedule-type-subscription';

@Injectable({
  providedIn: 'root'
})
export class RoleScheduleTypeSubscriptionService extends BaseService<RoleScheduleTypeSubscription, number> {

  constructor(protected override injector: Injector) {
    super(injector, '/role_schedule_type_subscription');
  }

  readByScheduleType(firstId: number) {
    const url = this.BASE_URL + this.endpoint + '/by_schedule_type/' + firstId;
    return this.http.get<RoleScheduleTypeSubscription[]>(url);
  }
}
